module.exports = __webpack_public_path__ + "3d06f51a3b8e6046da2d193a6adca4c6.png";